import type { ButtonProps } from "@certa/catalyst/components/Button";
import { Button, ButtonVariants } from "@certa/catalyst/components/Button";
import { useIntl } from "react-intl";
import { Plus } from "@certa/icons/components/Plus";
import { AddFilter } from "@certa/icons/components/AddFilter";
import { forwardRef } from "react";

type AddFilterButtonProps = ButtonProps & {
  noOfRules: number;
};

const ZERO_RULE = 0;

export const AddFilterButton = forwardRef<
  HTMLButtonElement,
  AddFilterButtonProps
>((props, ref) => {
  const { noOfRules, ...buttonProps } = props;

  const hasRules = noOfRules > ZERO_RULE;
  const Icon = hasRules ? AddFilter : Plus;

  const rulesText = useAddFilterButtonText(noOfRules);

  return (
    <Button
      {...buttonProps}
      leftIcon={<Icon />}
      variant={ButtonVariants.TEXT}
      ref={ref}
    >
      {rulesText}
    </Button>
  );
});

const useAddFilterButtonText = (count: number) => {
  const intl = useIntl();
  return intl.formatMessage(
    {
      id: `addFilterButton.rulesText`,
      defaultMessage:
        "{count, plural, =0 {Add Filter} one {{count, number} rule} other {{count, number} rules}}"
    },
    { count }
  );
};
